// extracted by mini-css-extract-plugin
module.exports = {"flex_box":"flex_box___oEjPI","flex_item":"flex_item___2Ct-D","title":"title___3ctfO"};